var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h3',{staticClass:"headline"},[_vm._v("License")]),_vm._l((_vm.license),function(part,i){return _c('p',{key:'license_p_' + i,domProps:{"textContent":_vm._s(part)}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }